import { useEffect } from "react";

function useScrollTop(scroll = true) {
    useEffect(() => {
        if(scroll) window.scrollTo(0, 0);
    }, [scroll])
}

export default useScrollTop;